var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-clear[data-v-421747c0] {\n  display: inline-block;\n  text-indent: -999em;\n  background: url(" + escape(require("../assets/img/x@2x.png")) + ") no-repeat;\n  width: 25px;\n  background-size: 25px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-421747c0","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-eef-app/src/css"],"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PagePreview.vue
// module id = 582
// module chunks = 1